import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20soft%20dramatic%20spotlights%2C%20elegant%20movie%20theater%20atmosphere%2C%20golden%20accents%2C%20luxurious%20and%20warm%20ambiance%2C%20professional%20cinema%20photography%20with%20shallow%20depth%20of%20field%2C%20no%20people%20visible&width=1600&height=900&seq=hero-banner-main&orientation=landscape"
        alt="麻花影院 - 免费在线观影平台"
        title="麻花影院免费观看"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-4xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 md:mb-6 leading-tight">
            麻花影院
            <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-2 text-accent-400">
              免费高清影视，畅享无限精彩
            </span>
          </h1>
          <p className="text-sm md:text-base text-background-200/80 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
            海量电影、电视剧、综艺、动漫、纪录片免费在线观看，高清画质不卡顿，每日更新，无需注册即可畅享极致观影体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/movie"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 cursor-pointer transition-all duration-200 whitespace-nowrap text-sm"
            >
              <i className="ri-play-circle-line mr-2"></i>开始观影
            </Link>
            <Link
              to="/category/tv"
              className="w-full sm:w-auto px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 font-medium rounded-full hover:bg-background-50/30 cursor-pointer transition-all duration-200 border border-background-50/30 whitespace-nowrap text-sm"
            >
              <i className="ri-tv-line mr-2"></i>热播剧集
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}